/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClimateMapPageResponse } from '../../models/climate-map-page-response';
import { LocalDateTime } from '../../models/local-date-time';

export interface GetClimateMapPageData$Params {
  facilityId?: number;
  fillMissingData?: boolean;
  groupIdx?: Array<number>;
  startDate?: LocalDateTime;
}

export function getClimateMapPageData(http: HttpClient, rootUrl: string, params?: GetClimateMapPageData$Params, context?: HttpContext): Observable<StrictHttpResponse<ClimateMapPageResponse>> {
  const rb = new RequestBuilder(rootUrl, getClimateMapPageData.PATH, 'get');
  if (params) {
    rb.query('facilityId', params.facilityId, {});
    rb.query('fillMissingData', params.fillMissingData, {});
    rb.query('groupIdx', params.groupIdx, {});
    rb.query('startDate', params.startDate, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClimateMapPageResponse>;
    })
  );
}

getClimateMapPageData.PATH = '/api/telemetry/climate-map';
